import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PageSearchState {
  clinical: string;
  watchlist: string;
  bedexits: string;
  myFacility: string;
  motionAndExits: string;
  trends: string;
  intercom: string;
  billing: string;
}

const initialState: PageSearchState = {
  clinical: "",
  watchlist: "",
  bedexits: "",
  myFacility: "",
  motionAndExits: "",
  trends: "",
  intercom: "",
  billing: "",
};

const pageSearchSlice = createSlice({
  name: "pageSearch",
  initialState,
  reducers: {
    setPageSearch: (
      state,
      action: PayloadAction<{ page: keyof PageSearchState; value: string }>
    ) => {
      const { page, value } = action.payload;
      state[page] = value;
    },
    clearPageSearch: (state, action: PayloadAction<keyof PageSearchState>) => {
      state[action.payload] = "";
    },
    clearAllPageSearches: (state) => {
      Object.keys(state).forEach((key) => {
        state[key as keyof PageSearchState] = "";
      });
    },
  },
});

export const { setPageSearch, clearPageSearch, clearAllPageSearches } =
  pageSearchSlice.actions;

export default pageSearchSlice.reducer;
